<template>
  <div class="rpg-pd-5">
    <div class="rpg-pd-5-10 rpg-bd-b rpg-pr-title">
      <span class="rpg-label">{{ project.客户公司 }}-{{ project.项目名称 }}</span>
      <span class="rpg-gray">（当前项目）</span>
    </div>
    <div class="rpg-pd-5-10 rpg-label">
      面试反馈
      <peixun type="9" style="display:inline-block;margin-left:5px;position:relative;top:3px;"></peixun>
    </div>
    <div>
      <div class="rpg-bd rpg-pd-5-10">
        <div class="rpg-tag-green">人选对职位的反馈</div>
        <div class="rpg-pd-5">
          <label>人选意愿：</label>
          <el-radio v-model="yiyuan" label="非常积极">非常积极</el-radio>
          <el-radio v-model="yiyuan" label="积极">积极</el-radio>
          <el-radio v-model="yiyuan" label="犹豫">犹豫需要推动</el-radio>
          <el-radio v-model="yiyuan" label="放弃">人选放弃</el-radio>
        </div>
        <div class="rpg-pd-5">
          <div>
            <span>反馈问题：</span> <span class="rpg-btn rpg-btn-outline" @click="showTmp">点击按照模板填写</span>
          </div>
          <el-input
            v-model="radishFeedback"
            type="textarea"
            rows="3"
            placeholder="填写人选面试反馈：见了谁、多长时间、沟通情况、问了那些问题、意向如何、有什么诉求等反馈信息；人选风险点以及给客户的建议（也可按照模板填写）"
          ></el-input>
          <el-checkbox v-model="sendWxRadish">发送微信消息通知客户经理</el-checkbox>
        </div>
        <div class="rpg-pd-5-10"></div>
        <div class="rpg-pd-5 rpg-text-right">
          <el-button size="mini" type="primary" @click="handleConfirmRadish">提交反馈</el-button>
        </div>
      </div>
      <div class="rpg-bd rpg-pd-5-10 rpg-mgb-5">
        <div class="rpg-tag-green">客户对人选的反馈</div>
        <div class="rpg-pd-5">
          <label>面试结果：</label>
          <el-radio v-model="result" label="合适">合适</el-radio>
          <el-radio v-model="result" label="淘汰">不合适（人选淘汰）</el-radio>
          <el-radio v-model="result" label="待定">待定</el-radio>
        </div>
        <div class="rpg-pd-5">
          <div>反馈问题：</div>
          <el-input
            v-model="clientFeedback"
            type="textarea"
            rows="3"
            placeholder="填写客户&客户经理对于人选的反馈以及疑问；"
          ></el-input>
          <el-checkbox v-model="sendWxClient">发送微信消息通知顾问</el-checkbox>
        </div>
        <div class="rpg-pd-5 rpg-text-right">
          <el-button size="mini" type="primary" @click="handleConfirmClient">提交反馈</el-button>
        </div>
      </div>
    </div>
    <div class="rpg-pd-5 rpg-bd-t">
      <div v-for="(feed, k) in feedbacks" :key="k">
        <div>
          <span class="rpg-gray rpg-mgr-5">{{ feed.时间 }}&nbsp;&nbsp;--{{ feed.顾问 }}</span>
          <span class="rpg-tag-green-sm">{{ feed.类型 }}</span>
        </div>
        <div>
          <pre class="rpg-pre"><i class="el-icon-warning"></i>{{ feed.内容 }}</pre>
        </div>
      </div>
    </div>
    <el-dialog
      title="人选面试反馈模板填写"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="60px"
      :modal="false"
      class="rpg-dialog"
    >
      <div>
        <el-form :model="formData" label-width="130px" size="mini">
          <el-form-item label="候选人:">
            <span>{{ formData.候选人 }}</span>
          </el-form-item>
          <el-form-item label="推荐顾问:">
            <span>{{ formData.推荐顾问 }}</span>
          </el-form-item>
          <el-form-item label="面试时间:">
            <span>{{ formData.面试时间 }}</span>
          </el-form-item>
          <el-form-item label="面试官:"> <el-input v-model="formData.面试官"></el-input> </el-form-item>
          <el-form-item label="面试时长:">
            <el-input v-model="formData.面试时长" placeholder="总体的面试时间"></el-input>
          </el-form-item>
          <el-form-item label="面试内容:">
            <el-input
              v-model="formData.沟通情况"
              type="textarea"
              placeholder="问了哪些问题，如何回答的？整体面试感觉如何？有哪些疑问？等面试情况，以便于把握人选"
            ></el-input>
          </el-form-item>
          <el-form-item label="人选意向:">
            <el-radio v-model="yiyuan" label="非常积极">非常积极</el-radio>
            <el-radio v-model="yiyuan" label="积极">积极</el-radio>
            <el-radio v-model="yiyuan" label="犹豫">犹豫需要推动</el-radio>
            <el-radio v-model="yiyuan" label="放弃">人选放弃</el-radio>
          </el-form-item>
          <el-form-item label="人选诉求:">
            <el-input v-model="formData.人选诉求" placeholder="面试之后人选诉求如何"></el-input>
          </el-form-item>
          <el-form-item label="人选动因:">
            <el-input v-model="formData.人选动因" placeholder="人选动因"></el-input>
          </el-form-item>
          <el-form-item label="人选目前薪酬:">
            <el-input v-model="formData.人选目前薪酬" placeholder="人选现在的薪酬情况"></el-input>
          </el-form-item>
          <el-form-item label="人选目前职级:">
            <el-input v-model="formData.人选目前职级" placeholder="人选现在的职级情况"></el-input>
          </el-form-item>
          <el-form-item label="离职周期:">
            <el-input v-model="formData.离职周期" placeholder="人选离职周期"></el-input>
          </el-form-item>
          <el-form-item label="预计到岗时间:">
            <el-input v-model="formData.预计到岗时间" placeholder="人选预计到岗时间"></el-input>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item>
            <template slot="label">
              风险点:
              <el-popover v-model="fengVisible" placement="left" trigger="click" width="320">
                1、人选是否有竞业禁止？<br />
                2、家人是否同意？<br />
                3、人选是否有项目或者其他工作如果离开，公司会不同意。<br />
                4、我们是否做了他的背景调查（口碑评价），如果客户录用前背景调查是否会通不过？
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </template>
            <el-input
              v-model="formData.风险点"
              placeholder="人选可能存在的风险点"
              @focus="fengVisible = true"
            ></el-input>
          </el-form-item>
          <el-form-item label="人选目前其他offer:">
            <el-input v-model="formData.人选目前其他offer" placeholder="人选目前其他offer"></el-input>
          </el-form-item>
          <el-form-item label="推进建议:">
            <el-input v-model="formData.推进建议" placeholder="给到客户&客户经理的建议"></el-input>
          </el-form-item>
          <el-form-item> <el-checkbox v-model="sendWxRadish">发送微信消息通知客户经理</el-checkbox> </el-form-item>
          <el-form-item> <el-button type="primary" @click="confirmTemplate">提交反馈</el-button> </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    radish: {
      type: Object,
    },
    project: {
      type: Object,
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      result: '合适',
      yiyuan: '非常积极',
      clientFeedback: '',
      radishFeedback: '',
      sendWxClient: true,
      sendWxRadish: true,
      rid: '',
      pid: '',
      feedbacks: [],
      interview: {},
      feedbackObj: null,
      formData: {},
      fengVisible: false,
      dialogVisible: false,
    }
  },
  async mounted() {
    this.rid = this.radish.rid || this.radish._id
    this.pid = this.project._id
    const res = await app.service('radish').findInterview({ rid: this.rid, pid: this.pid })
    if (res.status == 'success') {
      if (res.data.length > 0) {
        this.interview = res.data[0]
        if (res.data[0].面试反馈) {
          this.setFeedbacks(res.data[0].面试反馈)
        }
        this.clientFeedback = ''
        this.radishFeedback = ''
        this.result = '合适'
        this.yiyuan = '非常积极'
        this.sendWxClient = true
        this.sendWxRadish = true
        let formData
        if (this.interview.反馈模板) {
          formData = this.interview.反馈模板
        } else {
          formData = {
            候选人: this.interview.候选人,
            推荐顾问: this.interview.顾问,
            面试时间: this.interview.面试时间,
            面试官: this.interview.面试官,
          }
        }
        this.formData = formData
      } else {
        this.$message.error('未找到对应面试数据')
        this.$parent.showChat && this.$parent.showChat()
      }
    } else {
      this.$message.error(res.msg)
      this.$parent.showChat && this.$parent.showChat()
    }
  },
  methods: {
    openTrainingVideo() {
      app.root.$refs.TrainingVideoDialog.open('面试安排面试辅导')
    },
    async handleConfirmClient() {
      const dt = {
        结果: this.result,
        客户经理反馈: this.clientFeedback,
        sendWx: this.sendWxClient,
      }
      const res = await app.service('radish').addFeedback({ _id: this.interview._id, data: dt, type: 'interview' })
      if (res.status == 'success') {
        this.setFeedbacks(res.data.面试反馈)
        this.clientFeedback = ''
        this.result = '合适'
        this.sendWxClient = true
        this.onConfirm()
        this.$message.success('操作成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    async handleConfirmRadish() {
      const dt = {
        人选意愿: this.yiyuan,
        候选人反馈: this.radishFeedback,
        sendWx: this.sendWxRadish,
      }
      const res = await app.service('radish').addFeedback({ _id: this.interview._id, data: dt, type: 'interview' })
      if (res.status == 'success') {
        this.setFeedbacks(res.data.面试反馈)
        if (this.feedbackObj) {
          await app.service('radish').updateInterview({ _id: this.interview._id, data: { 反馈模板: this.feedbackObj } })
        }
        this.feedbackObj = null
        this.radishFeedback = ''
        this.yiyuan = '非常积极'
        this.sendWxRadish = true
        this.onConfirm()
        this.$message.success('操作成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    showTmp() {
      this.dialogVisible = true
    },
    confirmTemplate() {
      const textArr = []
      if (this.formData.人选意向) textArr.push(`意向：${this.yiyuan}`)
      if (this.formData.沟通情况) textArr.push(`面试内容：\n${this.formData.沟通情况}`)
      if (this.formData.人选动因 || this.formData.人选诉求)
        textArr.push(
          `人选动因： ${this.formData.人选动因 ? `\n动因：${this.formData.人选动因}` : ''} ${
            this.formData.人选诉求 ? `\n诉求：${this.formData.人选诉求}` : ''
          }`,
        )
      if (this.formData.人选目前薪酬 || this.formData.人选目前职级)
        textArr.push(`目前薪酬： ${this.formData.人选目前薪酬 || ''} ${this.formData.人选目前职级 || ''}`)
      if (this.formData.风险点 || this.formData.人选目前其他offer)
        textArr.push(
          `潜在的风险点： ${this.formData.风险点 ? `\n${this.formData.风险点}` : ''} ${
            this.formData.人选目前其他offer ? `\n人选目前其他offer：${this.formData.人选目前其他offer}` : ''
          }`,
        )
      if (this.formData.推进建议) textArr.push(`建议：\n${this.formData.推进建议}`)
      if (this.formData.离职周期 || this.formData.预计到岗时间)
        textArr.push(
          `其他： ${this.formData.离职周期 ? `\n离职周期：${this.formData.离职周期}` : ''} ${
            this.formData.预计到岗时间 ? `\n预计到岗时间：${this.formData.预计到岗时间}` : ''
          }`,
        )

      const text = textArr.reduce(
        (total, currentValue, currentIndex) => `${total + (currentIndex + 1)}、${currentValue}\n\n`,
        '',
      )
      const obj = JSON.parse(JSON.stringify(this.formData))
      this.feedbackObj = obj
      this.radishFeedback = text
      this.formData = {}
      this.handleConfirmRadish()
    },
    setFeedbacks(feedbacks) {
      this.feedbacks = feedbacks
        .map(f => {
          f.时间 = dateFormat(f.时间, 'yyyy-mm-dd HH:MM')
          return f
        })
        .sort((a, b) => (a.时间 < b.时间 ? 1 : -1))
    },
  },
}
</script>
<style>
@import '../../static/css/progress.css';
</style>
